import React, { useEffect, useState } from 'react';

type ModalMessageValidProps = {
    modalMessage: string;
    onClose: () => void;
};

const ModalMessageValid: React.FC<ModalMessageValidProps> = ({ modalMessage, onClose }) => {
    const [progress, setProgress] = useState(0);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                const newProgress = prev + 1;
                if (newProgress >= 100) {
                    clearInterval(interval);
                    setIsExiting(true);
                    setTimeout(onClose, 1500);
                }
                return newProgress;
            });
        }, 30);

        return () => clearInterval(interval);
    }, [onClose]);

    return (
        <div className={`modalValid ${isExiting ? 'exit' : 'enter'}`}>
            <div className="modal-content">
                <div className="progress-bar" style={{ width: `${progress}%` }} />
                <p>{modalMessage}</p>
                {/* <button onClick={onClose}>x</button> */}
            </div>
        </div>
    );
};

export default ModalMessageValid;
